










import { Vue, Component, Prop } from 'vue-property-decorator';
import { Menu } from '@/types/admin';

@Component
export default class TabMenu extends Vue {
  @Prop() tabs!: Menu[];
}
